import TrainOccupancyModal from './TrainOccupancyModal';

export default TrainOccupancyModal;
